var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomDesigns255X177(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "255px",
    height: "177px",
    viewBox: "0 0 255 177",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/customdesigns/255x177") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/customdesigns/255x177",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "measuring",
    transform: "translate(67, 28)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7176692,120 C25.8179045,120 24.9181397,119.65664 24.2318904,118.970156 L1.02972556,95.7681913 C-0.343241852,94.3954562 -0.343241852,92.1693614 1.02972556,90.796392 L90.7964348,1.02955128 C92.1691678,-0.343183761 94.3952594,-0.343183761 95.7682268,1.02955128 L118.970157,24.2312814 C119.629453,24.8905786 120,25.7847196 120,26.7170638 C120,27.649408 119.629688,28.5437835 118.970157,29.2028463 L29.203448,118.970156 C28.5169643,119.65664 27.617434,120 26.7176692,120 Z",
    id: "Path",
    fill: "#F41381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,27.0374583 C120,27.9670603 119.630963,28.8592914 118.974637,29.5156185 L29.5155825,118.974635 C28.8312287,119.65899 27.9343281,120 27.0397633,120 C26.1428628,120 25.2459622,119.65899 24.5616084,118.974635 L13,107.413001 L107.412795,13 L118.974404,24.5616337 C119.630729,25.2179608 120,26.1101919 120,27.0374583 Z",
    id: "Path",
    fill: "#C60E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7994353,0.251040238 C3.29205862,-0.351553724 1.53816913,0.150763741 0.589305331,1.54224623 C-0.0788987311,2.52210421 -0.169879263,3.7866633 0.270756527,4.88760107 L5.43676679,17.7949861 C6.37206537,20.1319661 9.39383523,20.7518571 11.1748552,18.9721246 L18.9713488,11.1802434 C20.7523688,9.40027718 20.1321107,6.38052878 17.7935135,5.44554978 L4.7994353,0.251040238 Z",
    id: "Path",
    fill: "#303026"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26, 26)",
    fill: "#303026"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84,11.8689474 L78.9988988,16.8676392 L68.1671074,6.03596184 C66.7860304,4.6548994 66.7860304,2.41597566 68.1671074,1.03491323 C69.5481844,-0.343792444 71.7847749,-0.346149205 73.1658518,1.03491323 L84,11.8689474 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3339062,23.5349184 L67.3328049,28.5336103 L58.1672617,19.3681635 C56.7861847,17.9871011 56.7861847,15.7481773 58.1672617,14.3671149 C59.5483387,12.9884092 61.787286,12.9884092 63.1660062,14.3671149 L72.3339062,23.5349184 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8669327,78.9989514 L11.8681883,84 L1.03404014,73.1659659 C-0.344680045,71.7849034 -0.344680045,69.5459797 1.03404014,68.167274 C2.4151171,66.7862116 4.6540644,66.7862116 6.03514137,68.167274 L16.8669327,78.9989514 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5330266,67.3329803 L23.5342821,72.3340289 L14.3663821,63.1662254 C12.9853052,61.7875197 12.9853052,59.548596 14.3663821,58.1675336 C15.7474591,56.7864711 17.9864064,56.7864711 19.3674834,58.1675336 L28.5330266,67.3329803 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.927974,15.8068244 C39.6894936,14.6452378 38.8835051,13.6809727 37.782591,13.2407034 L17.1810813,5 L5,17.1810198 L13.2405098,37.7824255 C13.6807814,38.883334 14.6450513,39.6893185 15.8066438,39.9277977 C16.0425372,39.9762462 16.2800768,40 16.5159702,40 C17.4421397,40 18.3424386,39.6349904 19.0103719,38.9665901 L38.9667615,19.0103012 C39.805206,18.1718609 40.1662193,16.9681759 39.927974,15.8068244 L39.927974,15.8068244 Z",
    id: "Path",
    fill: "#FFCE94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2965244,120 C96.4501162,120 93.7742084,118.891506 91.7615941,116.878647 L80.0404072,105.157409 C78.6531976,103.77043 78.6531976,101.521237 80.0404072,100.134021 L100.134107,80.0402341 C101.52108,78.6532553 103.770264,78.6532553 105.157473,80.0402341 L116.87866,91.7614718 C118.891511,93.7740948 120,96.450251 120,99.2964348 C120,102.143092 118.891511,104.819012 116.87866,106.831635 L106.831928,116.87841 C104.819077,118.891506 102.142933,120 99.2965244,120 L99.2965244,120 Z",
    id: "Path",
    fill: "#FAF907"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1362884,90 L80.044997,100.076236 C78.6516677,101.467249 78.6516677,103.722985 80.044997,105.114236 L91.8178929,116.869567 C93.8393859,118.888282 96.5273366,120 99.3860641,120 C102.245267,120 104.93298,118.888282 106.954473,116.869567 L112,111.831568 L90.1362884,90 Z",
    id: "Path",
    fill: "#D7D607"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#07A0C9",
    points: "38.8534147 14 105 80.1469899 80.1468196 105 14 38.8532444"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#067A99",
    transform: "translate(53.5713, 66.0126) rotate(-45) translate(-53.5713, -66.0126)",
    points: "44.7835434 19.235644 62.3589173 19.2356524 62.3589624 112.789599 44.7835884 112.789591"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDesigns255X177);
export default __webpack_public_path__ + "static/media/custom-designs_255x177.42651381c31e6413bdd69732af7432c9.svg";
export { ForwardRef as ReactComponent };